import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useLocation, useParams } from "react-router-dom";
import Blank from "../../../components/DefaultStyles/Blank";
import LineBox from "../../../components/DefaultStyles/LineBox";
import TitleWithLine from "../../../components/DefaultStyles/TitleWithLine";
import ManageFaqDetailTitle from "../../../components/pages/Manage/ManageFaq/ManageFaqDetail/ManageFaqDetailTitle";
import { TableBorder } from "../Sunset/SunsetDetail";
import ManageFaqDetailInput from "../../../components/pages/Manage/ManageFaq/ManageFaqDetail/ManageFaqDetailInput";
import SpaceBetween from "../../../components/DefaultStyles/SpaceBetween";
import LineBtn from "../../../components/Button/LineBtn";
import { atom, useRecoilState } from "recoil";
import { OptionType } from "../../../components/Filters/DropDown";
import { useApi } from "../../../hooks/useApi";
import Loader from "../../../components/DefaultStyles/Loader";
import ManageFaqDetailFooter from "../../../components/pages/Manage/ManageFaq/ManageFaqDetail/ManageFaqDetailFooter";
import { toast } from "react-toastify";
import useMy from "../../../hooks/useMy";
import { commonString, copyTextToClipboard } from "../../../AdminApi/commFunc";
import { isBeta } from "../../../AdminConfig";
import dayjs from "dayjs";
import {
  getString3ByKey,
  getSubsNameBySubsId3,
} from "../../../AdminApi/3.0_utils";
import moment from "moment";
import subscription_set from "../../../data_json/subscription_set.json";

export const faqInputState = atom<{
  category: OptionType;
  tag: string;
  search: OptionType[] | null;
  public: number;
  memo: string;
  title: string;
  content: string;
}>({
  key: "faqInputState",
  default: {
    category: {
      value: "",
      label: "선택",
    },
    tag: "",
    search: [],
    public: 0,
    memo: "",
    title: "",
    content: "",
  },
});

export default function ManageFaqDetail() {
  const { name } = useMy();
  const { pathname } = useLocation();
  const { faqId, noticeId, termsId } = useParams();

  const isFaq = Boolean(pathname.includes("faq"));
  const isNotice = Boolean(pathname.includes("notice"));
  const isAddFaq = Boolean(pathname.includes("add"));

  const pageIitle = commonString(pathname).title;
  const paramsId = isFaq ? faqId : isNotice ? noticeId : termsId;
  console.log(faqId, noticeId, termsId);
  console.log(paramsId);

  const [editMode, setEditMode] = useState(false);

  const [savedContent, setSavedContent] = useRecoilState(faqInputState);

  const [viewCount, setViewCount] = useState(0);
  const [category, setCategory] = useState<OptionType>({
    value: "",
    label: "선택",
  });
  const [tag, setTag] = useState("");
  const [search, setSearch] = useState<OptionType[] | null>([]);
  const [subsId, setSubsId] = useState<OptionType[] | null>([]);
  const [keyword, setKeyword] = useState<number[]>([]);
  const [check, setCheck] = useState({
    public: false, // 공개
    private: false, // 비공개
    normal: false, // 상단 고정
    top: false, // 상단 고정
    hasService: false, // 서비스 지정함
    noService: false, // 서비스 지정 안 함
  });
  const [publicRange, setPublicRange] = useState({
    faq: false,
    myparty: false,
  });
  const [party, setParty] = useState({
    state: {
      all: true,
      before: false,
      start: false,
      end: false,
    },
    role: {
      all: true,
      owner: false,
      member: false,
    },
  });
  const [memo, setMemo] = useState("");
  const [title, setTitle] = useState(""); // 제목
  const [contents, setContents] = useState(""); // 본문
  const [initContent, setInitContents] = useState("");
  const [admin, setAdmin] = useState(name);
  const [updateDate, setUpdateDate] = useState(
    dayjs().format("YYYY-MM-DD HH:mm:ss")
  ); // 업데이트 시간
  const [initkeyword, setInitKeyword] = useState<number[]>([]);
  const [initSubsList, setInitSubsList] = useState<number[]>([]);

  // 자주 묻는 질문 상세
  const { response, loading, error } = useApi({
    method: "get",
    url:
      paramsId && !isAddFaq
        ? `${isFaq ? "FAQ" : "notice"}/${paramsId}`
        : undefined,
  });

  const activatedSubscription = subscription_set.filter(
    (data) =>
      moment().isSameOrAfter(
        moment(data.SUBS_ADATE).format("YYYY-MM-DD HH:mm")
      ) && data?.SUBS_ACT === "activate"
  );

  useEffect(() => {
    if (search && search?.length > 0) {
      let valueList: number[] = [];

      search?.map((a) => valueList.push(Number(a.value)));

      setKeyword(valueList);
    }
  }, [search]);

  useEffect(() => {
    if (isAddFaq && !paramsId) {
      setSavedContent({
        category: {
          value: "",
          label: "선택",
        },
        tag: "",
        search: [],
        public: 0,
        memo: "",
        title: "",
        content: "",
      });
    }
  }, [isAddFaq, paramsId]);

  useEffect(() => {
    if (response?.status === 200) {
      const keywordList = response?.data?.keyword;
      let temp: OptionType[] = [];
      let tempInitKeyword: number[] = [];

      setInitKeyword(response?.data?.keyword);
      setViewCount(response?.data?.viewcount);
      setAdmin(response?.data?.admin);
      setUpdateDate(response?.data?.updatedate);
      setCategory({
        value: `${response?.data?.category?.id}`,
        label: response?.data?.category?.name,
      });
      setTag(response?.data?.tag);
      setCheck({
        public: response?.data?.ispublic > 0 ? true : false,
        private: response?.data?.ispublic === 0 ? true : false,
        normal: response?.data?.isTop === 0 ? true : false,
        top: response?.data?.isTop === 1 ? true : false,
        hasService: response?.data?.servsubsidList?.length > 0,
        noService:
          response?.data?.category?.name &&
          response?.data?.servsubsidList?.length === 0,
      });

      if (isFaq) {
        setParty({
          role: {
            all: response?.data?.grade === 2,
            owner: response?.data?.grade === 0,
            member: response?.data?.grade === 1,
          },
          state: {
            all: false,
            before: (response?.data?.status & 1) === 1,
            start: (response?.data?.status & 2) === 2,
            end: (response?.data?.status & 4) === 4,
          },
        });
        setPublicRange({
          faq: (response?.data?.ispublic & 1) === 1,
          myparty: (response?.data?.ispublic & 2) === 2,
        });

        const allSubsList = activatedSubscription?.map((s) => {
          const subsData = subscription_set?.find(
            (subs) => subs.SUBS_ID === s.SUBS_ID
          );
          const subsName = getString3ByKey(subsData?.SUBS_NM ?? 0);

          return {
            value: `${s.SUBS_ID}`,
            label: `${subsName}`,
          };
        });

        setInitSubsList(
          response?.data?.servsubsidList[0] === "0"
            ? activatedSubscription?.map((a) => a.SUBS_ID)
            : [...response?.data?.servsubsidList?.map((s: string) => +s)]
        );
        setSubsId(
          response?.data?.servsubsidList[0] === "0"
            ? allSubsList
            : response?.data?.servsubsidList?.map((s: string) => ({
                value: s,
                label: getSubsNameBySubsId3(+s),
              }))
        );
      }

      setMemo(response?.data?.desc);
      setTitle(response?.data?.title);
      setContents(response?.data?.content);
      setInitContents(response?.data?.content);

      for (let i = 0; i < keywordList?.length; i++) {
        const el = keywordList[i];

        temp.push({
          label: el.name,
          value: `${el.id}`,
        });
        tempInitKeyword.push(el.id);
      }

      setSearch(temp);
      setInitKeyword(tempInitKeyword);
    }
  }, [response, paramsId, isFaq]);

  useEffect(() => {
    if (error) {
      toast.error(
        error?.data ?? `${pageIitle} 상세 페이지 로드에 실패하였습니다.`
      );
    }
  }, [error]);

  return (
    <>
      <ManageFaqDetailTitle />

      <LineBox>
        <SpaceBetween>
          <TitleWithLine title="내용 작성하기" />

          <>
            {!isAddFaq && (
              <LineBtn
                btnText={`${pageIitle} 링크 복사`}
                icon="link"
                btnClickEvent={() => {
                  const domain = window.location.host?.includes("dev.linkid.pw")
                    ? "https://dev.linkid.pw"
                    : window.location.host?.includes("beta.linkid.pw")
                    ? "https://beta.linkid.pw"
                    : "https://linkid.pw";

                  copyTextToClipboard(
                    `${domain}/help/${commonString(pathname).route}${
                      commonString(pathname).route === "terms"
                        ? `?type=${
                            response?.data?.category?.name?.includes("개인")
                              ? "privacy-policy"
                              : "service"
                          }&id=${paramsId}`
                        : `/${paramsId}`
                    }`,
                    `${pageIitle} 링크가 복사되었습니다.`
                  );
                }}
              />
            )}
          </>
        </SpaceBetween>

        <Blank blankHeight={24} />

        <TableBorder />

        <FaqDetailContainer>
          <ManageFaqDetailInput
            viewCount={viewCount}
            category={category}
            setCategory={setCategory}
            tag={tag}
            setTag={setTag}
            search={search}
            setSearch={setSearch}
            check={check}
            setCheck={setCheck}
            memo={memo}
            setMemo={setMemo}
            title={title}
            setTitle={setTitle}
            contents={contents}
            setContents={setContents}
            editMode={isAddFaq || editMode}
            subsId={subsId}
            setSubsId={setSubsId}
            party={party}
            setParty={setParty}
            initContent={initContent}
            publicRange={publicRange}
            setPublicRange={setPublicRange}
          />
        </FaqDetailContainer>
      </LineBox>

      <ManageFaqDetailFooter
        category={category}
        tag={tag}
        search={search}
        check={check}
        memo={memo}
        title={title}
        contents={contents}
        keyword={keyword}
        editMode={editMode}
        setEditMode={setEditMode}
        admin={admin}
        updateDate={updateDate}
        initkeyword={initkeyword}
        publicRange={publicRange}
        party={party}
        subsId={
          subsId && subsId?.length > 0 ? subsId?.map((s) => +s.value!) : []
        }
        initSubsList={initSubsList}
      />

      {loading && <Loader />}
    </>
  );
}

const FaqDetailContainer = styled.div``;
